// app.config.ts
import { ApplicationConfig, APP_INITIALIZER, inject, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { KeycloakService } from '../app/services/keycloak.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/AuthInterceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { getBrowserLocale } from './shared/utils/locale.utils';

const initializeKeycloak = () => () => {
  const keycloakService = inject(KeycloakService);
  return keycloakService.init();
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    provideAnimations(),
    {
      provide: LOCALE_ID,
      useFactory: () => getBrowserLocale(),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [],
    },
  ],
};
